import { render, staticRenderFns } from "./MitraCode.vue?vue&type=template&id=6321dab5&"
import script from "./MitraCode.vue?vue&type=script&lang=js&"
export * from "./MitraCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports